<div class="app-shell" [class.sidebar-collapsed]="sidebarCollapsed">
  <aside class="sidebar">
    <div class="brand">
      <img src="/brand/inbordo-logo.svg" alt="InBordo" />
      <button
        class="sidebar-toggle"
        type="button"
        (click)="toggleSidebar()"
        [attr.aria-expanded]="!sidebarCollapsed"
        [attr.aria-label]="sidebarCollapsed ? 'Expand navigation' : 'Collapse navigation'"
        [attr.title]="sidebarCollapsed ? 'Expand navigation' : 'Collapse navigation'">
        <i class="pi" [ngClass]="sidebarCollapsed ? 'pi-angle-right' : 'pi-angle-left'"></i>
      </button>
    </div>

    <nav class="nav">
      <a
        *ngFor="let item of visibleNavItems"
        [routerLink]="item.route"
        routerLinkActive="active"
        class="nav-item"
        [attr.aria-label]="item.labelKey | translate"
        [attr.title]="sidebarCollapsed ? (item.labelKey | translate) : null"
      >
        <i class="pi" [ngClass]="item.icon"></i>
        <span class="nav-label">{{ item.labelKey | translate }}</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <button pButton class="ghost" type="button" [attr.title]="sidebarCollapsed ? ('nav.help' | translate) : null">
        <i class="pi pi-question-circle"></i>
        <span>{{ 'nav.help' | translate }}</span>
      </button>
      <button pButton class="ghost" type="button" (click)="logout()" [disabled]="signingOut">
        <i class="pi pi-sign-out"></i>
        <span>{{ signingOut ? ('nav.signingOut' | translate) : ('nav.signOut' | translate) }}</span>
      </button>
    </div>
  </aside>

  <div class="main">
    <header class="topbar">
      <div class="search" (click)="$event.stopPropagation()">
        <i class="pi pi-search"></i>
        <p-dropdown
          class="search-filter"
          [options]="searchTypeOptions"
          optionLabel="label"
          optionValue="value"
          [ngModel]="searchType"
          (onChange)="onSearchTypeChange($event.value)"
          [appendTo]="'body'">
        </p-dropdown>
        <input
          pInputText
          type="text"
          [value]="searchQuery"
          #searchInput
          (input)="onSearchInput(searchInput.value)"
          (focus)="onSearchFocus()"
          (keydown.enter)="openFirstSearchResult()"
          [placeholder]="'nav.searchPlaceholder' | translate"
        />
        <div class="search-results" *ngIf="showSearchResults">
          <button
            pButton
            type="button"
            class="search-result"
            *ngFor="let item of searchResults"
            (click)="openSearchResult(item)"
          >
            <div class="result-text">
              <strong>{{ item.label }}</strong>
              <small *ngIf="item.subLabel">{{ item.subLabel }}</small>
            </div>
            <span class="result-type">{{ item.itemType }}</span>
          </button>
        </div>
      </div>
      <div class="actions">
        <div class="quick-actions" (click)="$event.stopPropagation()">
          <button pButton class="primary" type="button" (click)="toggleQuickActions()">
            {{ 'nav.quickAction' | translate }}
          </button>
          <div class="quick-actions-menu" *ngIf="showQuickActions">
            <a class="quick-actions-item" routerLink="/members" (click)="closeQuickActions()">
              <i class="pi pi-user"></i>
              {{ 'dashboard.quickCreate.newMember' | translate }}
            </a>
            <a class="quick-actions-item" routerLink="/measurements" (click)="closeQuickActions()">
              <i class="pi pi-chart-line"></i>
              {{ 'dashboard.quickCreate.newMeasurement' | translate }}
            </a>
            <a class="quick-actions-item" routerLink="/classes" (click)="closeQuickActions()">
              <i class="pi pi-calendar"></i>
              {{ 'dashboard.quickCreate.newClass' | translate }}
            </a>
            <a class="quick-actions-item" routerLink="/memberships/new" (click)="closeQuickActions()">
              <i class="pi pi-id-card"></i>
              {{ 'dashboard.quickCreate.newMembership' | translate }}
            </a>
          </div>
        </div>
        <button pButton class="ghost" type="button" (click)="toggleLocale()">{{ localeLabel }}</button>
        <div class="avatar">AT</div>
      </div>
    </header>

    <section class="page">
      <div class="page-loading-overlay" *ngIf="routeLoading">
        <span class="loader-spinner" aria-hidden="true"></span>
        <strong>Loading data...</strong>
      </div>
      <router-outlet></router-outlet>
    </section>
  </div>
</div>
